import { render, staticRenderFns } from "./DeliveredModal.vue?vue&type=template&id=2e49ef50&"
import script from "./DeliveredModal.vue?vue&type=script&lang=js&"
export * from "./DeliveredModal.vue?vue&type=script&lang=js&"
import style0 from "./DeliveredModal.vue?vue&type=style&index=0&id=2e49ef50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports